import type { AccentType } from '../../types/AccentType';
import type { ResolvedTheme } from '../../types/ThemeType';

import { accentToCssVariables } from './accentToCssVariables';

export const applyAccentTokens = (
  accent: AccentType,
  theme: ResolvedTheme,
  root: HTMLElement = document.documentElement
): void => {
  const variables = accentToCssVariables(accent, theme);

  Object.entries(variables).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
};
